import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import vSelect from 'vue-select'
import { VBToggle, VBTooltip } from 'bootstrap-vue'


Vue.directive('b-tooltip', VBTooltip)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('v-select', vSelect)
